import { createSlice } from '@reduxjs/toolkit';
import { DocumentType } from "@nxsys/types/models/document";
import { documentAct } from '../action';

export const initialState = {
	loading: false,
	messageNotification: {
		text: '',
		type: '',
	},
	documents: {
		list: [] as DocumentType[],
		pagination: {
			current: 0,
			pageSize: 20,
			total: 0,
		},
		queryParams: null,
	},
};


const documentSlice = createSlice({
	name: 'documentSlice',
	initialState: initialState,
	reducers: {
		clearMessage: (state) => {
			state.messageNotification = { text: '', type: '' };
		},
	},
	extraReducers: (builder) => {
		builder.addCase(documentAct.getDocuments.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(documentAct.getDocuments.fulfilled, (state, action) => {
			state.loading = false;
			const list = action.payload.list?.map((item: DocumentType) => ({
				...item,
				companyPaymentId: item?.subcontractorRef?.companyPayment?.id || null, // for Bureau
			}));
			state.documents = { list, pagination: action.payload.pagination, queryParams: action.payload.queryParams };
		});
		builder.addCase(documentAct.getDocuments.rejected, (state) => {
			state.loading = false;
		});
		builder.addCase(documentAct.verifyDocument.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(documentAct.verifyDocument.fulfilled, (state, action) => {
			state.loading = false;

			const updatedDocument = action.payload?.data ?? action.payload;
			const index = state.documents.list.findIndex(
				(item: DocumentType) => item.id === updatedDocument?.id
			);

			if (index !== -1) {
				state.documents.list[index] = {
					...state.documents.list[index],
					documentStatus: updatedDocument.documentStatus,
				};
			}
		});
		builder.addCase(documentAct.verifyDocument.rejected, (state) => {
			state.loading = false;
		});
		builder.addCase(documentAct.updateDocument.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(documentAct.updateDocument.fulfilled, (state, action) => {
			state.loading = false;

			const updatedDocument = action.payload;
			const index = state.documents.list.findIndex(
				(item: DocumentType) => item.id === updatedDocument?.id
			);

			if (index !== -1) {
				state.documents.list[index] = {
					...state.documents.list[index],
					...updatedDocument,
				};
			}
		});
		builder.addCase(documentAct.updateDocument.rejected, (state) => {
			state.loading = false;
		});
		builder.addCase(documentAct.deleteDocument.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(documentAct.deleteDocument.fulfilled, (state, action) => {
			state.loading = false;
			state.documents.list = state.documents.list.filter(
				(item: DocumentType) => item.id !== action.payload.id
			);
		});
		builder.addCase(documentAct.deleteDocument.rejected, (state) => {
			state.loading = false;
		});
		builder.addCase(documentAct.createDocument.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(documentAct.createDocument.fulfilled, (state, action) => {
			state.loading = false;
			state.documents.list = [action.payload as DocumentType, ...state.documents.list];
			state.documents.pagination.total += 1;
		});
		builder.addCase(documentAct.createDocument.rejected, (state) => {
			state.loading = false;
		});
		//get by id
		builder.addCase(documentAct.getDocumentsById.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(documentAct.getDocumentsById.fulfilled, (state, action) => {
			state.loading = false;
			const list = action.payload.list?.map((item: DocumentType) => ({
				...item,
				companyPaymentId: item?.subcontractorRef?.companyPayment?.id || null, // for Bureau
			}));
			state.documents = { list, pagination: action.payload.pagination, queryParams: action.payload.queryParams };
		});
		builder.addCase(documentAct.getDocumentsById.rejected, (state) => {
			state.loading = false;
		});

		builder.addCase(documentAct.getDocumentById.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(documentAct.getDocumentById.fulfilled, (state) => {
			state.loading = false;
		});
		builder.addCase(documentAct.getDocumentById.rejected, (state) => {
			state.loading = false;
		});
	},
});

export const documentReducer = documentSlice.reducer;
export const documentActions = {
	...documentSlice.actions,
	...documentAct,
};
